import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isAndroid, isIOS } from '../../utils/deviceCheck';
import { useTranslation } from 'react-i18next';

function Navigation() {
  const location = useLocation();
  const { t } = useTranslation();
  const navTabsRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const searchParams = new URLSearchParams(location.search);
  const currentLang = searchParams.get('lang') || 'ja';
  const currentQr = searchParams.get('qr') || '';

  const commonSearch = `?qr=${currentQr}&lang=${currentLang}`;

  const tabs = [
    { name: t('nav.home'), path: '/' },
    { name: t('nav.manufacturing'), path: '/manufacturing-environment' },
    { name: t('nav.maintenance'), path: '/maintenance' },
    { name: t('nav.basicinfo'), path: '/basicinfo' }
  ];

  const deviceClass = isAndroid() ? 'android-style' : isIOS() ? 'ios-style' : '';

  useEffect(() => {
    const checkOverflow = () => {
      const el = navTabsRef.current;
      const isNowMobile = window.innerWidth < 768;
      setIsMobile(isNowMobile);
      if (isNowMobile && el) {
        setIsOverflowing(el.scrollWidth > el.clientWidth);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, []);

  const mobileStyle = isMobile
    ? {
        display: 'flex',
        flexDirection: 'row',
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        justifyContent: isOverflowing ? 'flex-start' : 'space-between',
      }
    : {};

  return (
   <nav className="box-nav">
  <div className="nav-tabs-wrapper">
    <div
      className={`nav-tabs ${deviceClass}`}
      ref={navTabsRef}
      style={mobileStyle}
    >
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path;
        return (
          <Link
            key={tab.path}
            to={{ pathname: tab.path, search: commonSearch }}
            className={`nav-tab ${isActive ? 'active' : ''}`}
          >
            {tab.name}
          </Link>
        );
      })}
    </div>
  </div>
</nav>
  );
}

export default Navigation;
